"use client";

import { openCookiePreferences } from "@/lib/cookie-consent-ui";

export function CookieSettingsLink({ label, className }: { label: string; className?: string }) {
  return (
    <button type="button" onClick={() => openCookiePreferences()} className={`cursor-pointer ${className ?? ""}`}>
      {label}
    </button>
  );
}
